<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M4.86849 6.25C6.06332 6.25 7.03192 5.29861 7.03192 4.12501C7.03192 2.95139 6.06332 2 4.86849 2C3.67367 2 2.70508 2.95139 2.70508 4.12501C2.70508 5.29861 3.67367 6.25 4.86849 6.25Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M0.597656 12.404C0.605213 11.6933 0.79606 10.9959 1.15237 10.3773C1.90323 9.07338 3.34531 8.24543 4.86998 8.24219C6.39464 8.24543 7.83672 9.07338 8.58759 10.3773C8.9439 10.9959 9.13474 11.6933 9.1423 12.404"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.8685 6.25C12.0633 6.25 13.0319 5.29861 13.0319 4.12501C13.0319 2.95139 12.0633 2 10.8685 2C9.67367 2 8.70508 2.95139 8.70508 4.12501C8.70508 5.29861 9.67367 6.25 10.8685 6.25Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.59766 12.404C6.60521 11.6933 6.79606 10.9959 7.15237 10.3773C7.90323 9.07338 9.34531 8.24543 10.87 8.24219C12.3946 8.24543 13.8367 9.07338 14.5876 10.3773C14.9439 10.9959 15.1347 11.6933 15.1423 12.404"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
